var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDownSolid = function SvgChevronDownSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.906 6.594-.718.687-3.907 3.907-.687.718L16 26.313l14.406-14.407-.687-.719-3.907-3.906-.718-.687L16 15.687Zm-.031 2.843 8.406 8.376.719.687.719-.687 8.406-8.375 2.438 2.437L16 23.469 4.438 11.875Z"
  })));
};
export default SvgChevronDownSolid;